import { render, staticRenderFns } from "./lesson.vue?vue&type=template&id=54592f77&scoped=true&"
var script = {}
import style0 from "./lesson.vue?vue&type=style&index=0&id=54592f77&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54592f77",
  null
  
)

export default component.exports